import { connect } from 'react-redux';

import InstallPrompt from 'Component/InstallPrompt';
import { PAGE_TYPE_HOME } from 'Component/Meta/Meta.config';
import { DEFAULT_STATE_NAME } from 'Component/NavigationAbstract/NavigationAbstract.config';
import {
    HomePageContainer as SourceHomePageContainer,
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps
} from 'SourceRoute/HomePage/HomePage.container';
import { updateMeta } from 'Store/Meta/Meta.action';
import { lazyComponentLoader } from 'Util/lazyComponentLoader';

export {
    mapStateToProps
};
export const CmsPage = lazyComponentLoader(
    () => import(/* webpackMode: "lazy", webpackChunkName: "cms-main" */ 'Route/CmsPage'), 2
);
/** @namespace Bodypwa/Route/HomePage/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch),
    updateMeta: (meta) => dispatch(updateMeta(meta))
});

/** @namespace Bodypwa/Route/HomePage/Container */
export class HomePageContainer extends SourceHomePageContainer {
    componentDidMount() {
        const { changeHeaderState, updateMeta } = this.props;
        updateMeta({
            page_type: PAGE_TYPE_HOME
        });
        changeHeaderState({
            name: DEFAULT_STATE_NAME,
            isHiddenOnMobile: false
        });
    }

    render() {
        return (
            <div block="HomePage">
                <InstallPrompt />
                <CmsPage { ...this.containerProps() } />
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePageContainer);
